import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { TripItineraryDetailComponent } from './trip-itinerary-detail.component';

@NgModule({
  declarations: [TripItineraryDetailComponent],
  imports: [CommonModule, MatIconModule, MatDividerModule],
  exports: [TripItineraryDetailComponent]
})
export class TripItineraryDetailModule {}
